import { useFormContext } from "react-hook-form";

import { useTheme } from "@up/data";
import { ELEMENT_WRAPPER_MB, ElementWrapper, LabelCheckbox } from "@up/form";

export function UnderAgeMarketingConsent() {
  const { register } = useFormContext();
  const KEY = "under-age-marketing-consent";
  const registerProps = register(KEY);
  const theme = useTheme();

  const label = `I agree to receive marketing emails about the ${theme.partnerOnlineName}. I
            understand that I may unsubscribe at any time.`;

  return (
    <ElementWrapper className={ELEMENT_WRAPPER_MB}>
      <LabelCheckbox Label={label}>
        <input
          className="kup-checkbox"
          id={`${registerProps["name"]}`}
          type="checkbox"
          {...registerProps}
        />
      </LabelCheckbox>
    </ElementWrapper>
  );
}
